<template src="./PantallaInicio.html"></template>

<script>
import {requestAfiliacionMixin} from "@/api/ciudadano/afiliacionApi";
import {requesServelMixin} from "@/api/servelApi";
import {NotifyMixin} from "@/mixins/NotifyMixin";
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import {Divider, Link} from "element-ui";

export default {
  name: "PantallaInicio",
  components: {
    [Divider.name]: Divider,
    [Link.name]: Link,
  },
  mixins: [
    requestAfiliacionMixin,
    NotifyMixin,
    ScreenSizeMixin,
    requesServelMixin
  ],
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    validateNoAfiliacion() {
      this.loading = true
      this.getAfiliacionPendiente()
        .then(response => {
          this.$log.debug('getAfiliacionPendiente', response.data.statusCode)
          if (response.data.statusCode === 200) {
            this.$emit('on-validation', false)
          } else if (response.data.statusCode === 400) {
            this.showError(`Tiene pendiente una solicitud de afiliación a un partido político.`)
            this.$emit('on-validation', true)
          } else if (response.data.statusCode === 409) {
            this.showError(`Se encuentra incorporado en el Registro General de Afiliados.`)
            this.$emit('on-validation', true)
          } else if (response.data.statusCode === 403) {
            this.showError(`No se encuentra vigente en el Registro Electoral.`)
            this.$emit('on-validation', true)
          } else if (response.data.statusCode === 406) {
            this.showError(`Los usuarios administradores de partidos políticos no pueden afiliarse.`)
            this.$emit('on-validation', true)
          } else {
            this.showError(`Ocurrió un error inesperado al cargar las validaciones.`)
            this.$emit('on-validation', true)
          }

          this.loading = false
        })
        .catch(err => {
          this.$log.fatal('getAfiliacionPendiente', err.response, err.request)
          this.showError('Ocurrió un error inesperado al cargar las validaciones')

          this.$emit('on-validation', true)
          this.loading = false
        })
    },
  }

}
</script>


